import pinkHydrangea from '../images/flowers/pinkHydrangea.png';
import pinkCallaLily from '../images/flowers/pinkCallaLily.png';
import pinkPeony from '../images/flowers/pinkPeony.png';
import pinkDahlia from '../images/flowers/pinkDahlia.png';
import pinkGerbera from '../images/flowers/pinkGerbera.png';
import pinkCosmos from '../images/flowers/pinkCosmos.png';
import pinkCarnation from '../images/flowers/pinkCarnation.png';
import pinkLily from '../images/flowers/pinkLily.png';

import purpleTulip from '../images/flowers/purpleTulip.png';
import purpleCalla from '../images/flowers/purpleCalla.png';
import purpleLavendar from '../images/flowers/purpleLavendar.png';
import purpleHydrangea from '../images/flowers/purpleHydrangea.png';
import purpleCosmo from '../images/flowers/purpleCosmo.png';
import purpleSage from '../images/flowers/purpleSage.png';
import purpleDahlia from '../images/flowers/purpleDahlia.png';
import purpleMorning from '../images/flowers/purpleMorning.png';

import greenMisc from '../images/flowers/greenMisc.png';
import greenDark from '../images/flowers/greenDark.png';
import greenEucalyptus from '../images/flowers/greenEucalyptus.png';
import greenHydrangea from '../images/flowers/greenHydrangea.png';
import greenCarnation from '../images/flowers/greenCarnation.png';
import greenPuff from '../images/flowers/greenPuff.png';
import greenFern from '../images/flowers/greenFern.png';
import greenFern2 from '../images/flowers/greenFern2.png';

import whiteCattail from '../images/flowers/whiteCattail.png';
import whiteBaby from '../images/flowers/whiteBaby.png';
import whiteCarnation from '../images/flowers/whiteCarnation.png';
import whiteLily from '../images/flowers/whiteLily.png';
import whiteHydrangea from '../images/flowers/whiteHydrangea.png';
import whitePeony from '../images/flowers/whitePeony.png';
import whiteGerbera from '../images/flowers/whiteGerbera.png';
import whiteRose from '../images/flowers/whiteRose.png';

import yellowSunflower from '../images/flowers/yellowSunflower.png';
import yellowSunflower1 from '../images/flowers/yellowSunflower1.png';
import yellowPeony from '../images/flowers/yellowPeony.png';
import yellowTulip from '../images/flowers/yellowTulip.png';
import yellowRose from '../images/flowers/yellowRose.png';
import yellowLily from '../images/flowers/yellowLily.png';
import yellowDaisy from '../images/flowers/yellowDaisy.png';
import yellowDaffodil from '../images/flowers/yellowDaffodil.png';

import redRose from '../images/flowers/redRose.png';
import redCarnation from '../images/flowers/redCarnation.png';
import redCosmos from '../images/flowers/redCosmos.png';
import redLily from '../images/flowers/redLily.png';
import redTulip from '../images/flowers/redTulip.png';
import redSage from '../images/flowers/redSage.png';
import redDaisy from '../images/flowers/redDaisy.png';
import redMorningGlory from '../images/flowers/redMorningGlory.png';

import blueHydrangea from '../images/flowers/blueHydrangea.png';
import blueMorning from '../images/flowers/blueMorning.png';
import blueCosmo from '../images/flowers/blueCosmo.png';
import blueLavendar from '../images/flowers/blueLavendar.png';
import blueStar from '../images/flowers/blueStar.png';
import blueBaby from '../images/flowers/blueBaby.png';
import blueSage from '../images/flowers/blueSage.png';
import blueCornflower from '../images/flowers/blueCornflower.png';

const flowers = [
    {
        "name": "greenMisc",
        "img": greenMisc,
        "color": "greens",
        "index": 0
    }, {
        "name": "greenDark",
        "img": greenDark,
        "color": "greens",
        "index": 1
    },
    {
        "name": "greenEucalyptus",
        "img": greenEucalyptus,
        "color": "greens",
        "index": 2
    },
    {
        "name": "greenHydrangea",
        "img": greenHydrangea,
        "color": "greens",
        "index": 3
    },
        {
        "name": "greenCarnation",
        "img": greenCarnation,
        "color": "greens",
        "index": 4
    },
        {
        "name": "greenPuff",
        "img": greenPuff,
        "color": "greens",
        "index": 5
    },
    {
        "name": "greenFern",
        "img": greenFern,
        "color": "greens",
        "index": 6
    },
        {
        "name": "greenFern2",
        "img": greenFern2,
        "color": "greens",
        "index": 7
    },
    {
        "name": "pinkHydrangea",
        "img": pinkHydrangea,
        "color": "pinks",
        "index": 8
    },
    {
        "name": "pinkCallaLily",
        "img": pinkCallaLily,
        "color": "pinks",
        "index": 9
    },
    {
        "name": "pink dahlia",
        "img": pinkDahlia,
        "color": "pinks",
        "index": 10
    },
    {
        "name": "pinkPeony",
        "img": pinkPeony,
        "color": "pinks",
        "index": 11
    },
    {
        "name": "pinkGerbera",
        "img": pinkGerbera,
        "color": "pinks",
        "index": 12
    },
    {
        "name": "pinkCosmos",
        "img": pinkCosmos,
        "color": "pinks",
        "index": 13
    },
    {
        "name": "pinkCarnation",
        "img": pinkCarnation,
        "color": "pinks",
        "index": 14
    },
    {
        "name": "pinkLily",
        "img": pinkLily,
        "color": "pinks",
        "index": 15
    },
    {
        "name": "purpleTulip",
        "img": purpleTulip,
        "color": "purples",
        "index": 16
    },
    {
        "name": "purpleLavendar",
        "img": purpleLavendar,
        "color": "purples",
        "index": 17
    },
    {
        "name": "purpleCalla",
        "img": purpleCalla,
        "color": "purples",
        "index": 18
    },
    {
        "name": "purpleHydrangea",
        "img": purpleHydrangea,
        "color": "purples",
        "index": 19
    },
        {
        "name": "purpleCosmo",
        "img": purpleCosmo,
        "color": "purples",
        "index": 20
    },
    {
        "name": "purpleSage",
        "img": purpleSage,
        "color": "purples",
        "index": 21
    },
        {
        "name": "purpleDahlia",
        "img": purpleDahlia,
        "color": "purples",
        "index": 22
    },
    {
        "name": "purpleMorning",
        "img": purpleMorning,
        "color": "purples",
        "index": 23
    },
    {
        "name": "red rose",
        "img": redRose,
        "color": "reds",
        "index": 24
    },
    {
        "name": "redLily",
        "img": redLily,
        "color": "reds",
        "index": 25
    },
    {
        "name": "redCosmos",
        "img": redCosmos,
        "color": "reds",
        "index": 26
    },
    {
        "name": "redCarnation",
        "img": redCarnation,
        "color": "reds",
        "index": 27
    },
        {
        "name": "redTulip",
        "img": redTulip,
        "color": "reds",
        "index": 28
    },
            {
        "name": "redSage",
        "img": redSage,
        "color": "reds",
        "index": 29
    },
            {
        "name": "redDaisy",
        "img": redDaisy,
        "color": "reds",
        "index": 30
    },
    {
        "name": "redMorningGlory",
        "img": redMorningGlory,
        "color": "reds",
        "index": 31
    },
    {
        "name": "yellowSunflower",
        "img": yellowSunflower,
        "color": "yellows",
        "index": 32
    },
    {
        "name": "yellowSunflower1",
        "img": yellowSunflower1,
        "color": "yellows",
        "index": 33
    },
    {
        "name": "yellowPeony",
        "img": yellowPeony,
        "color": "yellows",
        "index": 34
    },
        {
        "name": "yellowTulip",
        "img": yellowTulip,
        "color": "yellows",
        "index": 35
    },
        {
        "name": "yellowRose",
        "img": yellowRose,
        "color": "yellows",
        "index": 36
    },
    {
        "name": "yellowLily",
        "img": yellowLily,
        "color": "yellows",
        "index": 37
    },
        {
        "name": "yellowDaisy",
        "img": yellowDaisy,
        "color": "yellows",
        "index": 38
    },
        {
        "name": "yellowDaffodil",
        "img": yellowDaffodil,
        "color": "yellows",
        "index": 39
    },
    {
        "name": "white cattails",
        "img": whiteCattail,
        "color": "whites",
        "index": 40
    },
    {
        "name": "white babys breathe",
        "img": whiteBaby,
        "color": "whites",
        "index": 41
    },
    {
        "name": "white carnation",
        "img": whiteCarnation,
        "color": "whites",
        "index": 42
    },
    {
        "name": "white lily",
        "img": whiteLily,
        "color": "whites",
        "index": 43
    },
    {
        "name": "whiteHydrangea",
        "img": whiteHydrangea,
        "color": "whites",
        "index": 44
    },
    {
        "name": "whitePeony",
        "img": whitePeony,
        "color": "whites",
        "index": 45
    },
    {
        "name": "whiteGerbera",
        "img": whiteGerbera,
        "color": "whites",
        "index": 46
    },
    {
        "name": "whiteRose",
        "img": whiteRose,
        "color": "whites",
        "index": 47
    },
    {
        "name": "blueHydrangea",
        "img": blueHydrangea,
        "color": "blues",
        "index": 48
    },
    {
        "name": "blueMorning",
        "img": blueMorning,
        "color": "blues",
        "index": 49
    },
    {
        "name": "blueCosmo",
        "img": blueCosmo,
        "color": "blues",
        "index": 50
    },
        {
        "name": "blueStar",
        "img": blueStar,
        "color": "blues",
        "index": 51
    },
        {
        "name": "blueSage",
        "img": blueSage,
        "color": "blues",
        "index": 52
    },
        {
        "name": "blueLavendar",
        "img": blueLavendar,
        "color": "blues",
        "index": 53
    },
        {
        "name": "blueBaby",
        "img": blueBaby,
        "color": "blues",
        "index": 54
    },
        {
        "name": "blueCornflower",
        "img": blueCornflower,
        "color": "blues",
        "index": 55
    },
]

export default flowers;